import { CommonModule } from '@angular/common';
import { afterNextRender, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
declare global {
  interface Window {
    __stockist_reload: any;
  }
}
@Component({
  selector: 'app-stockist',
  imports: [CommonModule, RouterModule, DynamicModule],
  templateUrl: './stockist.component.html',
  styleUrl: './stockist.component.scss',
})
export class StockistComponent {
  @Input() _editable!: string;
  @Input() _uid!: string;
  @Input() component!: any;

  constructor() {
    afterNextRender(() => {
      setTimeout(() => {
        try {
          window['__stockist_reload']();
        } catch (err) {
          console.log(err);
        }
      }, 600);
    });
  }
}
